import React from 'react';
import '@ant-design/v5-patch-for-react-19';
import 'dayjs/locale/de';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Reflect the current build environment in the browser tab title so staff
// can't confuse staging with production at a glance.
const envAppName = (import.meta.env.VITE_APP_NAME as string | undefined) ?? '';
if (envAppName) {
  document.title = envAppName;
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('Root element not found!');
} else {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
